//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { ticketInfoModal } from '@/views/modals'
import { userInfo, funSticky } from './components'
export default {
  name: 'TicketListPage',
  extends: vComponent,
  components: { ticketInfoModal, userInfo, funSticky },
  data () {
    return {
      isShowCheckModal: false,
      items: [],
      info: null
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'dateFormat'
    ]),
    allowItems () {
      const result = this.items.filter((item) => {
        // 20240417 不判斷 event_e_date
        return item.isusage === 'N' && moment(item.e_date).isAfter()
        // return item.isusage === 'N' && moment(item.e_date).isAfter() && moment(item.event_e_date).isAfter()
      })
      // 由近的先排
      const sortResult = result.sort((a, b) => {
        return new Date(a.e_date) - new Date(b.e_date)
      })
      return sortResult
    },
    groupItems () {
      const tmp = {}
      this.allowItems.forEach(item => {
        if (tmp[`seq_${item.rul_seq}`] === undefined) tmp[`seq_${item.rul_seq}`] = []
        tmp[`seq_${item.rul_seq}`].push(item)
      })
      const result = []
      for (const prop in tmp) {
        result.push(tmp[prop])
      }
      return result
    }
  },
  async created () {
    await this.doQuery()
  },
  mounted () {
    this.addHandler()
    this.info = this.$refs.userInfo.currentVip
    /*
    setTimeout(() => {
      console.log(`groupItems== ${this.groupItems.length}`)
      this.groupItems.forEach((group, gIndex) => {
        console.log(`group==${group[0].rul_seq}-------`)
        group.forEach(item => {
          console.log(`---e_date=${item.e_date}`)
        })
      })
    }, 1000)
    */
  },
  methods: {
    addHandler () {
      this.on('TicketInfo.Used', (result) => {
        this.hideModal('infoModal')
        if (result === 'success') {
          this.doQuery()
        }
      })
    },
    async doQuery () {
      console.log('run query')
      const data = { ID_NO: this.params.id_no }
      const response = await this.fetch('pointTickets', this.site, data)
      this.items = response.data !== null ? response.data : []
      // console.log(`items===`)
      // console.log(this.items)
    },
    alert (message, callback = null) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        this.isShowCheckModal = false
        if (callback !== null) callback()
      })
    },
    getImgUrl (imgName) {
      if (imgName !== '' && imgName !== null) {
        return imgName
      } else {
        return 'static/images/default/default_product.png'
      }
    },
    formatDate (str) {
      return moment(str).format(this.dateFormat)
    },
    async clickOpenDetail (row) {
      this.showModal('infoModal', row)
    },
    clickNext (index, type) {
      console.log('click next')
    },
    clickPrev (index, type) {
      console.log('click prev')
    }
  }
}
